import { Drawer } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect, useState, useMemo } from 'react';
import { useSwipeable } from 'react-swipeable';
import { SearchIconStroke } from '../../../../../assets/icons/common/common-icons';
import { useStore } from '../../../../app/data/root.store';
import { SmartTagIcon } from '../../VaultMetadataPanel/MetadataLabelsSection/TagsTagCategory/SmartTagIcon';
import {
    DrawerWrapper,
    DrawerHeader,
    DrawerTitle,
    DrawerCloseButton,
    DrawerBody,
    SearchSection,
    SearchInputWrapper,
    SearchInput,
    SearchIcon,
    TagSection,
    TagSectionTitle,
    SelectedTagsWrapper,
    SelectedTag,
    SelectedTagContent,
    SelectedTagIcon,
    SelectedTagText,
    CheckmarkIcon,
    AllTagsWrapper,
    TagOption,
    TagOptionContent,
    TagOptionIcon,
    TagOptionText
} from '../../VaultMetadataPanel/MetadataLabelsSection/TagsTagCategory/TagEditorDrawer.styles';
import { PREDEFINED_TAG_NAMES } from '../../../data/vault-store';

export const TagsFilterDrawer = observer(({
    isOpen,
    onClose,
    selectedTags = [],
    onTagSelect,
}) => {
    const { vaultStore } = useStore();
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (isOpen && vaultStore.userTags.length === 0) {
            vaultStore.fetchUserTags();
        }
    }, [isOpen, vaultStore]);

    const filteredTags = useMemo(() => {
        if (!searchTerm) {
            return vaultStore.userTags;
        }
        return vaultStore.userTags.filter(tag =>
            tag.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
            tag.id.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [vaultStore.userTags, searchTerm]);

    const swipeHandlers = useSwipeable({
        onSwipedDown: () => onClose(),
        trackMouse: false
    });

    const handleTagToggle = (tag) => {
        onTagSelect(tag);
    };

    const selectedTagsFromStore = selectedTags || vaultStore.selectedTags;

    return (
        <Drawer
            closable={false}
            visible={isOpen}
            height={'auto'}
            placement="bottom"
            onClose={onClose}
            className="tag-editor-drawer-mobile"
            destroyOnClose={true}
        >
            <DrawerWrapper {...swipeHandlers}>
                <DrawerHeader>
                    <DrawerTitle>Tags</DrawerTitle>
                    <DrawerCloseButton onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#9097A3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </DrawerCloseButton>
                </DrawerHeader>

                <DrawerBody>
                    <SearchSection>
                        <SearchInputWrapper>
                            <SearchIcon>
                                <SearchIconStroke />
                            </SearchIcon>
                            <SearchInput
                                type="text"
                                placeholder="Search tags"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </SearchInputWrapper>
                    </SearchSection>

                    {selectedTagsFromStore.length > 0 && (
                        <TagSection>
                            <TagSectionTitle>Selected</TagSectionTitle>
                            <SelectedTagsWrapper>
                                {selectedTagsFromStore.map((tag) => (
                                    <SelectedTag key={tag.id || tag.name} onClick={() => handleTagToggle(tag)}>
                                        <SelectedTagContent>
                                            <SelectedTagIcon>
                                                <SmartTagIcon tagName={tag.id || tag.name} size={24} />
                                            </SelectedTagIcon>
                                            <SelectedTagText>{PREDEFINED_TAG_NAMES[tag.label] || tag.label || tag.tag}</SelectedTagText>
                                            <CheckmarkIcon>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M3 8L7 12L13 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </CheckmarkIcon>
                                        </SelectedTagContent>
                                    </SelectedTag>
                                ))}
                            </SelectedTagsWrapper>
                        </TagSection>
                    )}

                    <TagSection>
                        <TagSectionTitle>All tags</TagSectionTitle>
                        <AllTagsWrapper>
                            {filteredTags.filter(tag => !selectedTagsFromStore.some(selectedTag =>
                                (selectedTag.id || selectedTag.name) === (tag.id || tag.name)
                            )).map((tag) => (
                                <TagOption
                                    key={tag.id || tag.name}
                                    onClick={() => handleTagToggle(tag)}
                                >
                                    <TagOptionContent>
                                        <TagOptionIcon>
                                            <SmartTagIcon tagName={tag.id || tag.name} size={24} />
                                        </TagOptionIcon>
                                        <TagOptionText>{PREDEFINED_TAG_NAMES[tag.label] || tag.label || tag.tag}</TagOptionText>
                                    </TagOptionContent>
                                </TagOption>
                            ))}
                        </AllTagsWrapper>
                    </TagSection>
                </DrawerBody>
            </DrawerWrapper>
        </Drawer>
    );
}); 